<template>
  <div id="addBadge" class="tab-pane" role="tabpanel">
    <validation-observer ref="registerForm" #default="{ invalid }">
      <b-form>
        <b-row>
          <b-col lg="6">
            <b-form-group
              id="input-group-1"
              :label="$t('program_lists.name')"
              label-for="input-1"
            >
              <validation-provider
                #default="{ errors }"
                name="name"
                vid="name"
                rules="required"
              >
                <b-form-input
                  id="input-1"
                  v-model="newItem.name"
                  type="text"
                  :placeholder="$t('roles.name')"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <!-- .display_name -->
          <!-- <b-form-group
            id="input-group-2"
            :label="$t('roles.display_name')"
            label-for="input-2"
          >
            <b-form-input
              id="input-2"
              v-model="newItem.display_name"
              type="text"
              :placeholder="$t('roles.display_name')"
            />
          </b-form-group> -->
          <!-- .description -->
          <!-- <b-form-group
            id="input-group-3"
            :label="$t('roles.description')"
            label-for="input-3"
          >
            <b-form-textarea
              id="textarea-3"
              v-model="newItem.description"
              :placeholder="$t('roles.description')"
              rows="8"
            />
          </b-form-group> -->
        </b-row>
        <hr />
        <b-row>
          <div class="col-md-12 overflow-auto">
            <b-table :stacked="($mobile==1)" 
              responsive="sm"
              :items="items"
              :fields="fields"
            >
              <template #cell(show)="data">
                <b-form-checkbox
                  class="custom-control-success"
                  name="check-button"
                  v-model="newItem.permissions"
                  @change="selectItem(data)"
                  :value="data.item.id"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </template>
              <template #cell(add)="data">
                <b-form-checkbox
                  class="custom-control-success"
                  name="check-button"
                  v-model="recordIds"
                  @change="selectItem(data)"
                  :value="data.item.id"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </template>
              <template #cell(edit)="data">
                <b-form-checkbox
                  class="custom-control-success"
                  name="check-button"
                  v-model="recordIds"
                  :value="data.item"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </template>
              <template #cell(delete)="data">
                <b-form-checkbox
                  class="custom-control-success"
                  name="check-button"
                  v-model="recordIds"
                  @change="selectItem(data)"
                  :value="data.item.id"
                  switch
                >
                  <span class="switch-icon-left">
                    <feather-icon icon="CheckIcon" />
                  </span>
                  <span class="switch-icon-right">
                    <feather-icon icon="XIcon" />
                  </span>
                </b-form-checkbox>
              </template>
            </b-table>
          </div>
        </b-row>
        <hr />
        <b-row>
          <b-col lg="6">
            <b-button
              block
              :disabled="invalid"
              variant="primary"
              @click="submit()"
            >
              <i class="fa fa-plus" /> {{ $t("site.save") }}</b-button
            >
          </b-col>
          <b-col lg="6">
            <b-button block @click="goToTable()" variant="success">
              <i class="fas fa-ban"></i> {{ $t("site.cancel") }}</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import Controller from "../../../../Controllers/RolesController";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";

export default {
  name: "RolesForm",
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  props: ["newItem"],
  data() {
    return {
      file: {},
      show: [],
      items:[],
      fields: [
        {
          key: "name",
          label: this.$i18n.t("roles.name"),
          sortable: false,
        },
        // {
        //   key: "path",
        //   label: this.$i18n.t("roles.path"),
        //   sortable: false,
        // },
        {
          key: "show",
          label: this.$i18n.t("site.show"),
          sortable: false,
        },
        // {
        //   key: "add",
        //   label: this.$i18n.t("site.add"),
        //   sortable: false,
        // },
        // {
        //   key: "edit",
        //   label: this.$i18n.t("site.edit"),
        //   sortable: false,
        // },
        // {
        //   key: "delete",
        //   label: this.$i18n.t("site.delete"),
        //   sortable: false,
        // },
      ],
    };
  },
 async created() {
    this.items = await new Controller().allPermission();
  },
  methods: {
    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
    // async created() {
    //    const data = await controller.created();
    //    data.
    // },
  },
};
</script>
